/** Declare a readonly property with a null value on an classes prototype - used for declaring a "dto" */
export const Prop = (target: Object, key: string | symbol) => {
    Object.defineProperty(target, key, {
        configurable: false,
        enumerable: true,
        value: null,
        writable: false,
    });
};
